/**
 * Enum of asset types for a VistaAsset.
 * @readonly
 * @enum {string}
 */
export var AssetType;
(function (AssetType) {
    AssetType["Original"] = "Original";
    AssetType["Print"] = "Print";
    AssetType["WebPreview"] = "WebPreview";
    AssetType["Thumb"] = "Thumb";
    AssetType["BackgroundKnockout"] = "BackgroundKnockout";
    AssetType["Embroidery"] = "Embroidery";
    AssetType["Monochrome"] = "Monochrome";
    AssetType["Sharpened"] = "Sharpened";
    AssetType["Segmented"] = "Segmented";
    AssetType["ImageInfo"] = "ImageInfo";
    AssetType["Embroiderify"] = "Embroiderify";
    AssetType["InvertColor"] = "InvertColor";
})(AssetType || (AssetType = {}));
/**
 * Enum for Vista sub-brands.
 * @readonly
 * @enum {string}
 */
export var SubBrands;
(function (SubBrands) {
    SubBrands["VistaPrint"] = "VistaPrint";
    SubBrands["VistaCreate"] = "VistaCreate";
    SubBrands["Vista99D"] = "99Designs";
})(SubBrands || (SubBrands = {}));
/**
 * Tenants enum for default Vista tenants.
 * @readonly
 * @enum {string} Includes Vistaprint, VistaCreate, Vista99D, and VistaNonProd.
 */
export var Tenants;
(function (Tenants) {
    Tenants["VistaPrint"] = "wHqiv8SHZWp8fdGHeZ4Sp";
    Tenants["VistaCreate"] = "hJOHoP_bULB0KfG6vHZ3v";
    Tenants["Vista99D"] = "_lEO6aD8lq02u6QqsyZ_H";
    Tenants["VistaNonProd"] = "ol-ir4t7uFycQjunJdgCR";
    Tenants["VistaLogoMaker"] = "Qpf_04-CVu6JXKFddVYMe";
    Tenants["VistaLogoMakerNonProd"] = "X1MpaTDXiz8tdTiWGjqz_";
    Tenants["VistaCareSupport"] = "JqzyMexb118PYH7BJBqKY";
})(Tenants || (Tenants = {}));
export const tenantList = Object.values(Tenants);
export { AssetStoreFetchStatusType, AssetStatusType, } from '@design-stack-ct/assets-sdk';
//# sourceMappingURL=types.js.map